// Сравнение semver-версий веб-слоя.
//
// Тот же разбор, что на сервере (`apps/platform/services.parse_version`) и в
// `app/android/app/build.gradle` при расчёте versionCode: устройство, APK и сервер
// обязаны одинаково отвечать на вопрос «эта версия новее той».

/** `1.2.3` или `1.2.3-rc1` → `[1, 2, 3]`. Пре-релизный хвост отбрасывается. */
export function parseVersion(version: string): readonly number[] {
  const [core = version] = version.split('-');
  return core.split('.').map((part) => Number.parseInt(part, 10));
}

/** `true`, если `candidate` строго новее `current`. Нечисловые части → не новее. */
export function isNewer(candidate: string, current: string): boolean {
  const a = parseVersion(candidate);
  const b = parseVersion(current);
  if (a.some(Number.isNaN) || b.some(Number.isNaN)) return false;

  const length = Math.max(a.length, b.length);
  for (let i = 0; i < length; i += 1) {
    const left = a[i] ?? 0;
    const right = b[i] ?? 0;
    if (left !== right) return left > right;
  }
  return false;
}
